import { FaRegArrowAltCircleRight } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import ImageHeading from "../../components/ui/ImageHeading";
import RoundedButton from "../../components/ui/RoundedButton";
import DepartmentFacultyCard from "../../components/ui/Card/DepartmentFacultyCard";
import FeaturedEvents from "../../components/ui/FeaturedEvents";

import useAxiosPublic from "../../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../../components/Layout/LoadingPage";
const Academics = () => {
  const { slug } = useParams();

  const axiosPublic = useAxiosPublic();

  const {
    data: academicSchoolData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["academicSchool", slug],
    queryFn: async () => {
      const res = await axiosPublic.get(`/academics/school/${slug}`);
      return res?.data?.data;
    },
  });
  console.log(academicSchoolData);
  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }
  return (
    <div className="min-h-screen ">
      <ImageHeading
        heading={academicSchoolData?.school?.name}
        imageUrl={academicSchoolData?.school?.image_url}
        subHeading="Lorem ipsum dolor sit amet consectetur adipisicing elit."
      />
      {/* <div
        style={{
          backgroundImage: `url(${headerImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        className="flex justify-start relative items-center h-[50vh] text-white"
      >
        <div className="absolute inset-0 w-full h-full bg-black/40"></div>
        <div className="container absolute inset-0 left-0 mx-auto h-fit top-1/3">
          <div className="px-5 py-5 w-fit bg-primary">
            <h1 className="text-2xl font-bold md:text-3xl lg:text-4xl">
              School Of Business <br /> Administration
            </h1>
          </div>
        </div>
      </div> */}

      <div className="container px-4 py-12 mx-auto sm:px-6 lg:px-8">
        <section className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div className="col-span-2 space-y-4 text-gray-700 ">
            <p>{academicSchoolData?.school?.description}</p>
          </div>
          <div className="flex flex-col items-center space-y-4">
            {/* <div className="w-full pb-2 border-b border-primary">
              <Link className="flex items-center justify-between" to="/Schools">
                <h3 className="text-lg font-semibold text-primary">
                  Explore All Schools
                </h3>
                <FaRegArrowAltCircleRight className="text-primary" size={24} />
              </Link>
            </div> */}
            <div className="w-full pb-2 border-b border-primary">
              <Link
                className="flex items-center justify-between"
                to="/academics/academic-Calendar"
              >
                <h3 className="text-lg font-semibold text-primary">
                  Academic Calendar
                </h3>
                <FaRegArrowAltCircleRight className="text-primary" size={24} />
              </Link>
            </div>
            <div className="w-full pb-2 border-b border-primary">
              <Link
                className="flex items-center justify-between"
                to="http://103.60.173.170:94/Admission/Home.aspx"
              >
                <h3 className="text-lg font-semibold text-primary">
                  Apply Now
                </h3>
                <FaRegArrowAltCircleRight className="text-primary" size={24} />
              </Link>
            </div>
          </div>
        </section>
      </div>
      <div className=" relative text-gray-200 bg-[#AC0D30] overflow-hidden">
        {/* Background Pattern */}
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "radial-gradient(circle at 25px 25px, rgba(255, 255, 255, 0.2) 2%, transparent 0%), " +
              "radial-gradient(circle at 75px 75px, rgba(255, 255, 255, 0.2) 2%, transparent 0%)",
            backgroundSize: "100px 100px",
          }}
        />

        {/* Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#AC0D30]/50 to-[#AC0D30]" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />

        <div
          className={`container grid gap-10 px-4 py-12 mx-auto sm:px-6 lg:px-8 
    ${
      academicSchoolData?.school?.departments?.length === 1
        ? "grid-cols-1 place-items-center"
        : "md:grid-cols-2 lg:gap-0"
    }`}
        >
          {academicSchoolData?.school?.departments?.map((department) => (
            <div key={department?.slug} className="z-20 max-w-4xl lg:pr-24">
              <h3 className="text-3xl font-bold font-domine lg:text-4xl">
                {department?.name}
              </h3>
              <p className="mt-8 text-gray-200">{department?.description}</p>

              <div className="flex items-center justify-center">
                <RoundedButton
                  className="mt-8 py-4 font-bold font-display px-6 w-fit text-center border-white text-white"
                  spanClassName="text-white"
                  href={`/academics/department/${department?.slug}`}
                >
                  Explore {department?.name}
                </RoundedButton>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Faculty */}
      <div className="container px-4 py-12 mx-auto sm:px-6 lg:px-8 ">
        <h2 className="text-4xl font-bold text-center font-domine">
          Faculty members
        </h2>
        <div className="grid grid-cols-1 gap-5 my-12 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-8 lg:gap-6">
          {academicSchoolData?.school?.faculty?.map((faculty, index) => (
            <DepartmentFacultyCard key={index} {...faculty} />
          ))}
        </div>
        <div className="flex justify-center w-full">
          <RoundedButton href={"/discover-zums/faculty"}>
            View All Faculty Members
          </RoundedButton>
        </div>
      </div>

      <div className="container px-4 py-12 mx-auto sm:px-6 lg:px-8">
        <FeaturedEvents />
      </div>
    </div>
  );
};

export default Academics;
